import { graphql } from "react-relay";

export const ValidateAccountMutation = graphql`
  mutation ValidateAccountMutation($input: ValidateAccountInput!) {
    validateAccount(input: $input) {
      account {
        ...AccountDetailsMeta_account
        ...AccountDetailsStatus_account
        ...AccountStatusBadge_account
        email
        id
        key
        name
        path
        provider
        securityContext
        statusInfo {
          ...AccountStatus_statusInfo
          # Read by RevalidateAccount when the mutation completes.
          details {
            component
            message
            status
          }
        }
      }
    }
  }
`;
